
import { PRIVATE_CUSTOMER_FORM_SUFFIX_PATH, CORPORATE_CUSTOMER_FORM_SUFFIX_PATH } from "dynamic/routes";
import joinOfferUrlToPath from "utils/joinOfferUrlToPath";

export const PRIVATE_CUSTOMER = "PRIVATE";

export const CORPORATE_CUSTOMER = "CORPORATE";

/**
 * Returns the checkout path according to the customer type
 * and the offer url.
 * @param {*} offerUrl Th offer url
 * @param {*} customerType The customer type
 */
export const getCustomerTypeCheckoutPath = ({
  offerUrl,
  customerType,
}) => ({
  [PRIVATE_CUSTOMER]: joinOfferUrlToPath({
    offerUrl,
    path: PRIVATE_CUSTOMER_FORM_SUFFIX_PATH,
  }),
  [CORPORATE_CUSTOMER]: joinOfferUrlToPath({
    offerUrl,
    path: CORPORATE_CUSTOMER_FORM_SUFFIX_PATH,
  }),
})[customerType];

/**
 * Returns the offer list path according to the customer type.
 * @param {*} customerType The customer type
 */
export const getOfferListPagePath = (customerType) => ({
  [PRIVATE_CUSTOMER]: "/suche?pbo=privat",
  [CORPORATE_CUSTOMER]: "/suche?pbo=gewerbe",
})[customerType];

/**
 * Checks if a customer can access an offer based on its type and the offer information.
 */
export const checkIsCustomerTypeInvalid = ({
  selectedProduct,
  customerType,
}) => (
  (
    customerType === PRIVATE_CUSTOMER
    && selectedProduct?.isBusinessOnly
  )
  || (
    customerType === CORPORATE_CUSTOMER
    && selectedProduct?.isPrivateOnly
  )
);
